import styled, { css } from 'styled-components';
import { Input } from 'reactstrap';
import { get, inputColor } from '@whitelabel/helpers/style/get';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { fontWeight } from '@whitelabel/helpers/style/type';
import StyledCustomInput from '../../styled/StyledCustomInput';

export const StyledInput = styled(Input)`
  ${({ type }) =>
    type === 'textarea' &&
    css`
      && {
        height: 9.875rem;
      }
    `}
  && {
    padding-right: 0.9375rem;
  }

  border: ${get('borderWidth')} solid ${inputColor('border', 'default')};
  background-color: ${inputColor('background', 'default')};
  color: ${inputColor('value', 'default')};

  &:hover:not(.is-invalid) {
    border: ${get('borderWidth')} solid ${inputColor('border', 'hover')};
    cursor: pointer;
    background-color: ${inputColor('background', 'hover')};
    color: ${inputColor('value', 'hover')};
  }

  &:focus {
    border: ${get('borderWidth')} solid ${inputColor('border', 'focus')};
    cursor: pointer;
    background-color: ${inputColor('background', 'focus')};
    color: ${inputColor('value', 'focus')};
  }

  &:active {
    border: ${get('borderWidth')} solid ${inputColor('border', 'active')};
    background-color: ${inputColor('background', 'active')};
    color: ${inputColor('value', 'active')};
  }

  &:disabled {
    border: ${get('borderWidth')} solid ${inputColor('border', 'disabled')};
    background-color: ${inputColor('background', 'disabled')};
    color: ${inputColor('value', 'disabled')};
  }
`;

export const StyledCheckboxInputWrapper = styled.div`
  ${StyledCustomInput} {
    padding: 0;
  }

  .form-check-label {
    color: ${themeColor('anchor')} !important;
    font-size: 0.875rem;
    font-weight: ${fontWeight('base')};
    padding: 0;
    padding-inline: 1.75rem;
  }

  .form-check-label::before,
  .form-check-label::after {
    left: 0;
    transform: none;
    top: 0;
  }
`;
